import React, { memo } from 'react'

import * as Styled from './styled'
import { IProps } from './types'
import Icon from 'common-components/Icon'
import { TIconSize } from 'common-components/Icon/types'

const ButtonWithIcon: React.FC<IProps> = ({
  icon,
  iconSize = 'small',
  label,
  onClick,
  className,
  isDisabled
}) => {
  return (
    <Styled.ButtonWithIcon
      onClick={onClick}
      className={className}
      $isDisabled={isDisabled}
    >
      <Icon icon={icon} size={iconSize as TIconSize} color="textSecondary" />
      <span>{label}</span>
    </Styled.ButtonWithIcon>
  )
}

export default memo(ButtonWithIcon)
